var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 40,
    cy: 30,
    r: 5.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.503
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.667 1.667h36.666v36.666H1.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 20c0 3.376 1.39 6.417 3.606 8.617L6.25 32.222h9.167v-9.166l-3.423 3.422c-1.65-1.665-2.688-3.942-2.688-6.478a9.152 9.152 0 016.11-8.632V8.175C10.147 9.535 6.25 14.301 6.25 20zm12.222 7.639h3.056v-3.056h-3.056v3.056zM33.75 7.778h-9.167v9.166l3.423-3.422c1.65 1.666 2.688 3.942 2.688 6.478a9.152 9.152 0 01-6.11 8.632v3.193c5.27-1.36 9.166-6.126 9.166-11.825 0-3.376-1.39-6.417-3.606-8.617l3.606-3.605zm-15.278 13.75h3.056V12.36h-3.056v9.167z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
}
export default SvgSyncOffline;